import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import ImageComponent from "../../component/core/image";
import ImageSystemPolicy from "src/assets/image/our-system-policy-page-image/img-system-policy.png"

export default function Content() {

    const { t } = useTranslation();

    return (
        <div className='flex flex-col gap-10 max-w-[1280px] mx-auto px-6 py-12 relative w-full'>
            <ImageComponent src={ImageSystemPolicy} alt='image-system-policy'
                className='w-full'
                height={400} width={480} />
        </div>
    );
}
